import styles from "./App.module.less";
import AppRoute from "./components/appRoute/AppRoute";
import AppHeader from "./components/appHeader/AppHeader";
import I18nWrapperProvider from "~/providers/I18nProvider";
import PostMessageHandler from "~/components/postMessageHandler/PostMessageHandler";
import UserLogProvider from "~/providers/UserLogProvider";
import ChatButton from "~/components/chatButton/ChatButton";
import AuthenticationProvider, {
  useAuthenticationContext,
} from "~/providers/AuthenticationProvider";
import { BrowserRouter } from "react-router-dom";
import { ChatProvider } from "~/contexts/ChatContext";
import { CopilotMessageProvider } from "~/providers/CopilotMessageProvider";

function App() {
  return (
    <BrowserRouter>
      <AuthenticationProvider>
        <I18nWrapperProvider>
          <UserLogProvider>
            <CopilotMessageProvider>
              <AppRoute />
              <AppWrapper />
            </CopilotMessageProvider>
          </UserLogProvider>
        </I18nWrapperProvider>
      </AuthenticationProvider>
    </BrowserRouter>
  );
}

function AppWrapper() {
  const { token, isAuthLoading } = useAuthenticationContext();

  return (
    <div className={styles.App}>
      <PostMessageHandler />
      {!isAuthLoading && token ? (
        <ChatProvider>
          <AppHeader />
          <ChatButton />
        </ChatProvider>
      ) : null}
    </div>
  );
}

export default App;
